module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "dedibreak"
  }, [_c('span', {
    staticClass: "dedibreak1"
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('span', {
    staticClass: "dedication1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("I dedicate this novel to my deceased parents, Esther and G.L. (Fritz) Meyer, as well as my siblings, Shirley, Betty, Marilyn, and Louis.")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('span', {
    staticClass: "dedication1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("My fond memories and appreciation for family history are treasured gifts I hope to share with all of you. Enjoy!")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('span', {
    staticClass: "dedication1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "frame"
  }, [_c('img', {
    staticClass: "frame1",
    attrs: {
      "alt": "85592.png",
      "src": "OEBPS/image/85592.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('span', {
    staticClass: "dedication1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('span', {
    staticClass: "dedication1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("A WARM THANK YOU!")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('span', {
    staticClass: "dedication1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("Writing about the charming communities in East Perry County could not have happened without the generosity of the following people:")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('span', {
    staticClass: "dedication1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("Pat Rappa, Pearline and Larry Degenhardt, Nancy Hadler, Carla Jordan, Imogene Unger, Dot McQuade, Audrey Kennedy, Carole Martens, Joan Brown, Aileen Petzoldt and my many relatives and friends, who were born and raised in these communities.")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('span', {
    staticClass: "dedication1"
  }), _c('span', {
    staticClass: "dedication1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("A big thank you as well to all the residents, businesses, and museums, who continue to preserve this county for future generations. ")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('span', {
    staticClass: "dedication1"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "normal"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-539f8396","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/forgiv_ebook2.vue
// module id = 66
// module chunks = 0